import { AdditionalText, BodyText, TextProps } from '@ui-components/typography/Typography'
import { createGlobalStyle, css, styled } from 'styled-components'

import { Colors } from './colors'
import {
  DEFAULT_INPUT_MAX_WIDTH_PX,
  FONT_FAMILY_S_BONUS_UX,
  STEP_HEADER_BOTTOM_MARGIN,
  VERTICAL_PADDING_DEFAULT,
} from './constants'
import { SPACE_SMALL, SPACE_XXXSMALL } from './spacing'

export const FlexColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const CenteredFlexColumnContainer = styled(FlexColumnContainer)`
  align-items: center;
`

export const FlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const ConsentContainer = styled(FlexColumnContainer)`
  gap: 50px;
  margin-bottom: 50px;
`

export const LabelWrapper = styled.div`
  width: 100%;
  max-width: 540px;
`
export const ResponsiveButtonContainer = styled.div<{ $hasMarginTop?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: end;
  gap: ${VERTICAL_PADDING_DEFAULT}px;
  margin-top: ${(props) => props.$hasMarginTop && SPACE_SMALL};
  flex-wrap: wrap;
  > * {
    flex: 1 1 content;
    width: 100%;
    white-space: nowrap;
    min-width: calc(50% - ${VERTICAL_PADDING_DEFAULT / 2}px);
  }

  > * {
    width: 100%;
  }
`

interface InputFieldWrapperProps {
  $width?: string
  $readonly?: boolean
  $disabled?: boolean
}

export const InputFieldWrapper = styled.div<InputFieldWrapperProps>`
  width: ${(props) => props.$width ?? ''};
  opacity: ${(props) => (props.$disabled ? 0.35 : '')};
  @media (max-width: ${DEFAULT_INPUT_MAX_WIDTH_PX + 20}px) {
    max-width: 100%;
  }
`

export const NarrowInputFieldWrapper = styled(InputFieldWrapper)`
  max-width: ${DEFAULT_INPUT_MAX_WIDTH_PX}px;
  @media (max-width: ${DEFAULT_INPUT_MAX_WIDTH_PX + 20}px) {
    max-width: 100%;
  }
`

export const ErrorSpacerWithReservedSpace = styled.div`
  min-height: 23px;
`

export const PaddedDiv = styled.div`
  padding-top: 10px;
`

export const MediumErrorLabel = styled(BodyText).attrs({ tagName: 'div' })`
  color: ${Colors.TextError};
`

export const ErrorLabel = styled(AdditionalText)<TextProps>`
  display: block;
  color: ${Colors.TextError};
  width: 100%;
  margin-top: ${SPACE_XXXSMALL};
`

export const InputFieldPrefix = styled(BodyText)<TextProps>`
  line-height: 20px;
  padding-right: 8px;

  color: ${Colors.TextDefaultNeutral};
  margin: auto 0;
`

export const SecondaryHeaderWrapper = styled.div<{ $fixedToTop: boolean }>`
  ${({ $fixedToTop }) => {
    if ($fixedToTop) {
      return css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        margin-bottom: 53px;
        max-width: 100vw;
      `
    }
  }}
  z-index: 1;
  margin-bottom: ${STEP_HEADER_BOTTOM_MARGIN}px;
`

export const mainContentAttributes = {
  role: 'main',
}

export const GlobalStyle = createGlobalStyle`
  body {
    min-width: 300px;
    background-color: ${Colors.BackgroundWeakNeutral};
    box-sizing: border-box;
    color: ${Colors.TextDefaultNeutral};
    font-family: ${FONT_FAMILY_S_BONUS_UX};
  }

  p:not(:last-child) {
    margin-bottom: 1rem;
  }
`
